import { typeDownloadCenter } from "./downloadCenter"
import { queryDownloadCenter } from "./queries/queryDownloadCenter"

const downloadCenterSchema = {
  types: [typeDownloadCenter],
  resolvers: {
    Query: {
      ...queryDownloadCenter,
    },
    Mutation: {},
  },
}

export default downloadCenterSchema
